import { animate, style, transition, trigger } from '@angular/animations';

export const SHOW_HIDE_ANIMATION = trigger('showHide', [
  transition('void => *', [
    style({ opacity: 0 }),
    animate(200, style({ opacity: 1 })),
  ]),
  transition('* => void', [animate(200, style({ opacity: 0 }))]),
]);
